(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('WhatsAppController', whatsapp);

  whatsapp.$inject = ['$timeout', '$scope', '$http', '$stateParams', '$location', 'CompanyService', 'WhatsAppWebService', 'FoundationApi', 'Upload', 'ChatService', '$state', 'NotificationService', 'PermissionService'];

  function whatsapp ($timeout, $scope, $http, $stateParams, $location, CompanyService, WhatsAppWebService, FoundationApi, Upload, ChatService, $state, NotificationService, PermissionService) {
    var vm = this;

    	vm.metadata = {};
    vm.baseUrl = baseUrl;

    	CompanyService.findForChannel({
      type: 'whatsapp'
    }, function (data) {
      vm.company = data;

      if (!vm.number) {
        vm.number = {};
        vm.number.company_id = vm.company.id;
      }
      if (vm.company.metadata !== undefined && vm.company.metadata !== null) {
        for (var i in vm.company.metadata) {
          if (typeof vm.company.metadata[i]['value'] === 'string') {
            vm.metadata[vm.company.metadata[i]['key']] = JSON.parse(vm.company.metadata[i]['value']);
          } else {
            vm.metadata[vm.company.metadata[i]['key']] = vm.company.metadata[i]['value'];
          }
        }
      }
      if (vm.company.web_channels) {
        for (var i in vm.company.web_channels) {
          vm.company.web_channels[i]['can_send_active'] = (vm.company.web_channels[i]['can_send_active'] === 1);
          vm.company.web_channels[i]['banned'] = (vm.company.web_channels[i]['banned'] === 1);
        }
      }
    });
    vm.openModalWhatsApp = function () {
      FoundationApi.publish('addNumberModal', 'open');
    };

    	vm.uploadFiles = function (file, index, number) {
         	if (file) {
         		if (file.length) {
         			var params = {};
         			if (number.id !== undefined) {
         				params.id = number.id;
         			}
         			params.company_id = $stateParams.id;
         			file.upload = Upload.upload({
		                url: apiUrl + '/web-channel-photo-upload',
		                fields: params,
		                file: file
		            });

		            file.upload.then(function (response) {
		             	$timeout(function () {
		                   number.profile_picture_path = response.data.url;
		                });
		            }, function (response) {
		                if (response.status > 0) { var message = $scope.labels.errorProccessReq; }
			                if (response) {
			                    if (response.data) {
                if (response.data.message) { message = response.data.message; }
              }
			                }
		                 	FoundationApi.publish('main-notifications', { title: $scope.labels.error, content: message, autoclose: '3000', color: 'alert' });
		            });
            	}
         	}
    };
    // NUMEROS WHATSAPP
    vm.cadastrarWhatsApp = function () {
      vm.number = {};
      vm.number.company_id = vm.company.id;
      FoundationApi.publish('addNumberModal', 'open');
    }
    vm.editar = function (whatsapp) {
      vm.number = whatsapp;
      FoundationApi.publish('addNumberModal', 'open');
    }
    vm.saveNumber = function (number) {
      vm.number = number;
      vm.number.company_id = vm.company.id;

      if (!vm.number.phone_number) {
        return NotificationService.warningHandler(null, $scope.labels.errorPhone);
      }
      if (!vm.number.name) {
        return NotificationService.warningHandler(null, $scope.labels.errorName);
      }
      if (!vm.number.default_sector_id || vm.number.default_sector_id == 0) {
        return NotificationService.warningHandler(null, $scope.labels.errorSector);
      }
      if (vm.number.id == undefined) {
            	WhatsAppWebService.create({},
            		vm.number,
            		function (data) {
            vm.number = {};
            vm.number.company_id = vm.company.id;
	                	vm.company.web_channels.push(data);
	                	FoundationApi.publish('main-notifications', { title: 'Salvo!', content: 'Os dados foram criados com sucesso!', autoclose: '3000', color: 'success' });
	            	},
	            	function (error) {
		                var message = $scope.labels.errorProccessReq;
		                if (error) {
		                    if (error.data) {
                if (error.data.message) { message = error.data.message; }
              }
		                }
	                 	FoundationApi.publish('main-notifications', { title: $scope.labels.error, content: message, autoclose: '3000', color: 'alert' });
	            });
      } else {
            	WhatsAppWebService.update({
	                id: vm.number.id
	            }, vm.number,
	            function (data) {
          // vm.due_date = null;
          NotificationService.successHandler(data, 'Os dados foram atualizados com sucesso!');
	                FoundationApi.publish('main-notifications', { title: $scope.labels.saved, content: 'Os dados foram atualizados com sucesso!', autoclose: '3000', color: 'success' });
	            }, function (error) {
	                var message = 'Erro ao processar requisição, por favor tente novamente.'
	                if (error) {
	                    if (error.data) {
              if (error.data.message) { message = error.data.message; }
            }
	                }
	                FoundationApi.publish('main-notifications', { title: $scope.labels.error, content: message, autoclose: '3000', color: 'alert' });
	            });
      }
      FoundationApi.publish('addNumberModal', 'close');
    }
    vm.formatNumber = function (number) {
      var other = number;
      var country_code = '+' + other.substr(0, 2);
      var area_code = other.substr(2, 2);
      var number = number.substr(4);
      return country_code + ' (' + area_code + ') ' + number;
    }

    vm.insertCode = function (number) {
      vm.number = number;
      vm.create_number = 'code';
      FoundationApi.publish('addNumberModal', 'open');
    }
    vm.sendCode = function (number) {
      FoundationApi.publish('addNumberModal', 'close');
    }

    vm.goToTriggers = function (channel) {
      $state.go('main.triggers', { type: 'wwpp', id: channel.id });
    }

    vm.openPermissionsModal = function () {
      vm.operatorFilter = '';
      vm.allOperatorsSelected = false;
      vm.operatorsSelectedCount = 0;
      vm.selectedUsers = {}
      FoundationApi.publish('activePermissionsModal', 'open');
      PermissionService.get({ channelPrefix: 'waweb' })
        .$promise
        .then(function (permissions) {
          vm.usersPermissions = permissions;
          permissions.forEach(function (user) {
            vm.selectedUsers[user.id] = user.enabled;
            if (user.enabled) ++vm.operatorsSelectedCount;
          });
          if (permissions.length === vm.operatorsSelectedCount) vm.allOperatorsSelected = true;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao carregar permissões de usuário.')
        })
    }

    vm.setUserPermission = function (index) {
      return vm.usersPermissions[index].enabled;
    }

    vm.selectAllOperators = function () {
      if (vm.allOperatorsSelected) vm.operatorsSelectedCount = vm.usersPermissions.length;
      else vm.operatorsSelectedCount = 0;
      vm.usersPermissions.forEach(function (user) {
        vm.selectedUsers[user.id] = vm.allOperatorsSelected;
      });
    }

    vm.setUserSelected = function (userId) {
      if (!vm.selectedUsers[userId]) {
        vm.allOperatorsSelected = false;
        --vm.operatorsSelectedCount
      } else {
        ++vm.operatorsSelectedCount;
      }
      if (vm.usersPermissions.length === vm.operatorsSelectedCount) vm.allOperatorsSelected = true;
    }

    vm.savePermissionsModal = function () {
      vm.usersPermissions.forEach(function (user) {
        user.enabled = vm.selectedUsers[user.id];
      })
      PermissionService.set({
        userData: vm.usersPermissions,
        channelPrefix: 'waweb'
      })
        .$promise
        .then(function () {
          NotificationService.successHandler(null, 'Permissões atribuídas com sucesso.');
          FoundationApi.publish('activePermissionsModal', 'close');
          delete vm.usersPermissions;
          delete vm.selectedUsers;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao atribuir permissões de usuário.')
        });
    }
  }
})();
